import { CopilotType } from 'libs/end-to-end/src/copilot';

export const CopilotOrder: CopilotType[] = [
  'hiring',
  'pay-benchmarking',
  'pay-correction',
  'promotion',
];

export const getTabsForCopilotPage = ({
  hiringCopilotEnabled,
  promotionCopilotEnabled,
  payBenchmarkingEnabled,
  payCorrectionEnabled,
}: {
  hiringCopilotEnabled: boolean;
  promotionCopilotEnabled: boolean;
  payBenchmarkingEnabled: boolean;
  payCorrectionEnabled: boolean;
}) => {
  const unsortedTabs = [
    ...(hiringCopilotEnabled
      ? [
          {
            displayedValue: 'Hiring',
            tabValue: 'hiring',
            automationTag: 'hiring',
          } as const,
        ]
      : []),

    ...(payBenchmarkingEnabled
      ? [
          {
            displayedValue: 'Pay Benchmarking',
            tabValue: 'pay-benchmarking',
            automationTag: 'pay benchmarking',
          } as const,
        ]
      : []),

    ...(payCorrectionEnabled
      ? [
          {
            displayedValue: 'Pay Correction',
            tabValue: 'pay-correction',
            automationTag: 'pay correction',
          } as const,
        ]
      : []),

    ...(promotionCopilotEnabled
      ? [
          {
            displayedValue: 'Promotion',
            tabValue: 'promotion',
            automationTag: 'promotion',
          } as const,
        ]
      : []),
  ];

  // Sort the tabs based on the CopilotOrder
  return CopilotOrder.map((type) =>
    unsortedTabs.find((tab) => tab.tabValue === type),
  ).filter((tab) => tab !== undefined);
};
